import { useRef, useEffect, RefObject } from 'react'

export function useRegisterClick<Args extends unknown[]>(
  callback: (...args: Args) => void,
  ...args: Args
): RefObject<HTMLElement> {
  const htmlReference = useRef<HTMLElement>(null)

  useEffect(() => {
    const handleClick = () => {
      callback(...args)
    }
    const element = htmlReference.current
    if (element) {
      element.addEventListener('click', handleClick)
    }

    return () => {
      if (element) {
        element.removeEventListener('click', handleClick)
      }
    }
  }, [callback, args])

  return htmlReference
}
